import * as React from 'react'
import { useParams, useHistory } from 'react-router'

import EmbeddingCyclrIntegrationContainer from 'components/EmbeddingCyclrIntegration/container'
import { IntegrationContainer } from 'components/IntegrationContainer'

export default function EmbeddingCyclrIntegrationPage() {
  const { connectorId } = useParams()
  const history = useHistory()

  const isValidConnectorId = Boolean(parseInt(connectorId))
  const validConnectorId = isValidConnectorId ? connectorId : null

  React.useEffect(() => {
    if (!isValidConnectorId) {
      history.push('/settings/integrations/')
    }
  }, [connectorId, history, isValidConnectorId])

  return (
    <IntegrationContainer>
      <EmbeddingCyclrIntegrationContainer connectorId={validConnectorId} />
    </IntegrationContainer>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Admin/Integrations/Cyclr/Embedding/index.tsx